import React, { useEffect, useState } from "react";
import { useLoader } from "../../context/LoaderContext";
import { useUserDataContext } from "../../context/UserDataContext";
import { checkUser, fetchUserById } from "../../api/UserApi";
import { dynamicFailed } from "../../hooks/useToast";
import { IMemberListData } from "../../exports/interfaces";
import ProfileDetails from "../../components/user/member/ProfileDetails";
import { openLogin } from "../../exports/exports";
import { useNavigate } from "react-router-dom";

const MemberDashboard = () => {
  const { setLoading } = useLoader();
  const [listMemberData, setListMemberData] = useState<IMemberListData[]>([]);
  const { userData, setUserData } = useUserDataContext();
  const navigate = useNavigate();

  const accessToken = localStorage.getItem("frcsit:access-token");
  useEffect(() => {
    setLoading(true);
    if (!userData) {
      if (accessToken === null || accessToken === undefined) {
        openLogin();
        return;
      }
      Promise.all([checkUser(accessToken)])
        .then(([userData]) => {
          setUserData(userData);
          // userData?.data?.status === "0" && navigate("/error");
          userData?.data?.roles[0]?.name !== "member" && openLogin();
        })
        .catch(() => {
          dynamicFailed("Server Error");
        });
    }
  }, [accessToken, navigate, setLoading, setUserData, userData]);
  useEffect(() => {
    if (userData) {
      // userData?.data?.status === "0" && navigate("/error");
      Promise.all([fetchUserById(userData?.data?.id)])
        .then(([data]) => {
          setListMemberData(data);
          setTimeout(() => {
            setLoading(false);
          }, 1000);
        })
        .catch(() => {
          dynamicFailed("Server Error");
          setTimeout(() => {
            setLoading(false);
          }, 1000);
        });
    }
  }, [navigate, setLoading, userData]);
  return (
    <>
      <ProfileDetails listMemberData={listMemberData} />
    </>
  );
};

export default MemberDashboard;
